module.exports = __webpack_public_path__ + "static/media/sad-filly.ce4f7936.png";